import BaseModel from '../BaseModel';

export default class CandidatePhoto extends BaseModel {
  static entity = 'candidatePhotos';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      candidateId: this.attr(null),
      interviewType: this.string(null).nullable(),
      type: this.string(null).nullable(),
      url: this.string(null).nullable(),
    };
  }
}
